/* eslint-disable react/jsx-curly-brace-presence */
import React, { ReactElement } from 'react';

const sectionTitleStyle: React.CSSProperties = {
  fontSize: '17px',
  fontWeight: 700,
  color: '#1d1c1d',
  marginTop: '28px',
  marginBottom: '10px',
  lineHeight: '1.4em',
};

const paragraphStyle: React.CSSProperties = {
  fontSize: '14px',
  lineHeight: '1.7em',
  color: '#444',
  whiteSpace: 'pre-wrap',
  marginBottom: '12px',
};

const tableStyle: React.CSSProperties = {
  width: '100%',
  borderCollapse: 'collapse',
  fontSize: '13px',
  marginBottom: '12px',
  color: '#444',
};

const thStyle: React.CSSProperties = {
  background: '#f7f9fc',
  border: '1px solid #e5ebf3',
  padding: '10px 12px',
  textAlign: 'left',
  fontWeight: 700,
  color: '#1d1c1d',
};

const tdStyle: React.CSSProperties = {
  border: '1px solid #e5ebf3',
  padding: '10px 12px',
  lineHeight: '1.6em',
  verticalAlign: 'top',
};

function MBTIPersonalInfoTerm(): ReactElement {
  return (
    <div style={{ color: '#1d1c1d' }}>
      <p style={{ ...paragraphStyle, marginTop: 0 }}>
        {`(주)헬리큐어(이하 "회사")는 정보통신망 이용촉진 및 정보보호 등에 관한 법률, 개인정보보호법 등 관련 법령상의 개인정보보호 규정을 준수하며, 이용자(이하 "이용자")의 권익 보호에 최선을 다하고 있습니다.

본 개인정보 처리방침은 회사가 제공하는 "한의진단 MBTI" 서비스(https://prod.d3s2wjwpjlsdpk.amplifyapp.com, 이하 "서비스") 이용에 적용됩니다.`}
      </p>

      <h3 style={sectionTitleStyle}>1. 개인정보의 수집 및 이용 목적</h3>
      <p style={paragraphStyle}>
        {`회사는 다음의 목적을 위해 이용자의 개인정보를 처리하며, 목적이 변경되는 경우 별도의 동의를 받는 등 필요한 조치를 이행합니다.

· 한의진단 MBTI 서비스 제공
· 진단 페이지 안내를 위한 카카오톡 알림톡 발송
· 서비스 이용 기록 관리 (설문 응답·접속 로그)`}
      </p>

      <h3 style={sectionTitleStyle}>2. 수집하는 개인정보의 항목 및 보유 기간</h3>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>구분</th>
            <th style={thStyle}>수집 항목</th>
            <th style={thStyle}>보유 기간</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>한의진단 MBTI 이용자</td>
            <td style={tdStyle}>
              {`1) 이름, 성별, 만 나이, 휴대전화번호
2) 서비스 이용 기록 (설문 응답, 접속 로그)`}
            </td>
            <td style={tdStyle}>{`신청일로부터 5년
(관련 법령에 따라 별도 보관되는 정보는 예외)`}</td>
          </tr>
        </tbody>
      </table>

      <h3 style={sectionTitleStyle}>3. 개인정보의 제3자 제공</h3>
      <p style={paragraphStyle}>
        {`회사는 원칙적으로 이용자의 개인정보를 외부에 공개하지 않습니다. 다만 다음 각 호의 경우에는 예외로 합니다.

1) 이용자가 사전에 동의한 경우
2) 법령에 규정이 있거나 법령상 의무 준수를 위해 불가피한 경우
3) 수사기관이 수사 목적을 위해 관계 법령이 정한 절차를 거쳐 요구하는 경우
4) 통계 작성 및 학술 연구 등의 목적을 위해 필요한 경우로서 특정 개인을 알아볼 수 없는 형태로 제공하는 경우`}
      </p>

      <h3 style={sectionTitleStyle}>4. 개인정보 처리의 위탁</h3>
      <p style={paragraphStyle}>
        {`회사는 원활한 서비스 운영을 위해 다음과 같이 개인정보 처리 업무를 위탁하고 있습니다.`}
      </p>
      <table style={tableStyle}>
        <thead>
          <tr>
            <th style={thStyle}>수탁업체</th>
            <th style={thStyle}>위탁 업무 내용</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td style={tdStyle}>비즈톡 주식회사</td>
            <td style={tdStyle}>카카오 알림톡·문자 발송</td>
          </tr>
          <tr>
            <td style={tdStyle}>Amazon Web Services, Inc.</td>
            <td style={tdStyle}>IT 시스템(서버·데이터베이스) 운영</td>
          </tr>
        </tbody>
      </table>
      <p style={paragraphStyle}>
        {`회사는 위탁계약을 통해 수탁자가 개인정보를 안전하게 처리하도록 관리·감독하고 있으며, 위탁 업무 수행 목적 외 개인정보 처리 금지, 안전성 확보 조치 등 필요한 사항을 규정하고 있습니다.`}
      </p>

      <h3 style={sectionTitleStyle}>5. 개인정보의 파기 절차 및 방법</h3>
      <p style={paragraphStyle}>
        {`이용자의 개인정보는 수집·이용 목적이 달성되거나 보유 기간이 경과한 경우, 또는 이용자가 파기를 요청한 경우 지체 없이 파기합니다.

1) 파기 절차: 파기 대상 정보는 개인정보 보호책임자의 책임 아래 파기됩니다. 다른 법령에 따라 보존해야 하는 경우에는 예외적으로 파기하지 않을 수 있습니다.
2) 파기 방법: 전자적 파일 형태로 저장된 개인정보는 복원이 불가능한 방법으로 영구 삭제하며, 종이 문서는 분쇄 또는 소각합니다.`}
      </p>

      <h3 style={sectionTitleStyle}>6. 정보주체의 권리·의무 및 행사 방법</h3>
      <p style={paragraphStyle}>
        {`이용자는 언제든지 회사에 대하여 자신의 개인정보 열람·정정·삭제·처리 정지를 요구할 수 있습니다. 요청은 아래의 개인정보 보호책임자에게 서면, 전화 또는 이메일로 연락하시면 지체 없이 처리합니다.`}
      </p>

      <h3 style={sectionTitleStyle}>7. 개인정보의 안전성 확보 조치</h3>
      <p style={paragraphStyle}>
        {`회사는 이용자의 개인정보가 분실, 도난, 유출, 변조 또는 훼손되지 않도록 다음과 같은 조치를 강구합니다.

1) 기술적 조치: 개인정보 암호화 저장, 접근 통제, 침입 차단·탐지 시스템 운영
2) 관리적 조치: 개인정보 접근 권한을 최소한의 인원으로 제한, 담당자 정기 교육 실시`}
      </p>

      <h3 style={sectionTitleStyle}>8. 개인정보 보호책임자</h3>
      <p style={paragraphStyle}>
        {`개인정보 처리 관련 문의·불만 처리·피해 구제 등은 아래 담당자에게 연락 주시기 바랍니다.

· 담당자: 조성옥
· 전화번호: 010-9074-8755
· 이메일: healicure@gmail.com`}
      </p>

      <h3 style={sectionTitleStyle}>9. 권익침해 구제 방법</h3>
      <p style={paragraphStyle}>
        {`개인정보 침해로 인한 구제가 필요한 경우 아래 기관에 문의하실 수 있습니다.

· 개인정보 침해신고센터 (한국인터넷진흥원 운영) : privacy.kisa.or.kr / (국번없이) 118
· 개인정보 분쟁조정위원회 : www.kopico.go.kr / (국번없이) 1833-6972
· 대검찰청 사이버범죄수사단 : www.spo.go.kr / 02-3480-3573
· 경찰청 사이버안전국 : cyberbureau.police.go.kr / 182`}
      </p>

      <h3 style={sectionTitleStyle}>10. 개인정보 처리방침의 변경</h3>
      <p style={paragraphStyle}>
        {`본 개인정보 처리방침은 시행일로부터 적용되며, 법령 및 정책의 변경에 따라 내용이 추가·삭제·수정될 수 있습니다. 변경 시 서비스 내 공지를 통해 안내합니다.`}
      </p>
    </div>
  );
}

export default MBTIPersonalInfoTerm;
